import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";
import { trackAnalytics } from "@/lib/analytics";
import { materialTypes } from "@/lib/pricing";
import type { MaterialType } from "@/types/booking";
import type { StepProps } from "@/components/booking/steps/types";
import { StepFrame } from "@/components/booking/steps/StepFrame";

export function GrabStep({ state, isLocked, updateState, goNext, goBack }: StepProps) {
  function selectMaterialType(materialType: MaterialType) {
    updateState({ materialType });
    trackAnalytics("material type selected", { materialType });
    goNext();
  }

  return (
    <StepFrame title="Choose material type" description="This placeholder step keeps grab-hire branching explicit for future backend rules." canBack onBack={goBack} hideNext isReadOnly={isLocked}>
      <RadioGroup className="grid gap-3 md:grid-cols-2">
        {materialTypes.map((material) => (
          <Label key={material.id} className="flex cursor-pointer gap-3 rounded-lg border-2 border-accent/10 bg-white p-4">
            <RadioGroupItem
              name="materialType"
              checked={state.materialType === material.id}
              onChange={() => selectMaterialType(material.id)}
              readOnly={isLocked}
              disabled={isLocked}
            />
            <span>
              <span className="block font-black">{material.title}</span>
              <span className="text-sm text-muted-foreground">{material.description}</span>
            </span>
          </Label>
        ))}
      </RadioGroup>
    </StepFrame>
  );
}
